import api from "./api";

// Terminal list for the settings page, including each terminal's passcodes.
async function getTerminalSettings() {
  try {
    const response = await api.get(`api/terminals/settings`);
    return response.data;
  } catch (error) {
    return [];
  }
}

// Terminals the current user can send payments to (POS tab picker, no passcodes).
async function getPosTerminals() {
  try {
    const response = await api.get(`api/terminals`);
    return response.data;
  } catch (error) {
    return [];
  }
}

// Sends a payment to a terminal; returns the session the portal polls for the outcome.
// Throws on failure so the caller can show the error state.
async function initiateTerminalPayment({
  providerTerminalId,
  amount,
  reference,
  customerName,
}) {
  const response = await api.post(`api/terminals/payment-sessions`, {
    providerTerminalId,
    amount,
    reference,
    customerName,
  });
  return response.data;
}

async function getTerminalPayment(id) {
  const response = await api.get(`api/terminals/payment-sessions/${id}`);
  return response.data;
}

export {
  getTerminalSettings,
  getPosTerminals,
  initiateTerminalPayment,
  getTerminalPayment,
};
